import { http } from "@shared/utils/request";

export interface UserOptionItem {
    id: string;
    corpId: string;
    corpName: string;
    tel: string;
    nick: string;
}

interface UserOptionsData {
    items: UserOptionItem[];
}

/** 当前企业用户选项（下拉筛选用） */
export function fetchUserOptions(): Promise<UserOptionsData> {
    return http.get<UserOptionsData>("/customer/user/options");
}
